import { Tag } from '@blueprintjs/core';
import { debt_registry } from '@axo/shared/data-access/types';
export const DebtTypeTag = ({
  debtType,
}: {
  debtType: debt_registry.DebtRegistryEntryType;
}) => {
  const getColor = () => {
    switch (debtType) {
      case debt_registry.DebtRegistryEntryType.RepaymentLoan:
        return 'primary';
      case debt_registry.DebtRegistryEntryType.ChargeCard:
        return 'warning';
      case debt_registry.DebtRegistryEntryType.CreditFacility:
        return 'success';
      default:
        return 'none';
    }
  };

  const getName = () => {
    switch (debtType) {
      case debt_registry.DebtRegistryEntryType.RepaymentLoan:
        return 'Repayment loan';
      case debt_registry.DebtRegistryEntryType.ChargeCard:
        return 'Charge card';
      case debt_registry.DebtRegistryEntryType.CreditFacility:
        return 'Credit facility';
      default:
        return 'none';
    }
  };

  const getIcon = () => {
    switch (debtType) {
      case debt_registry.DebtRegistryEntryType.RepaymentLoan:
        return 'dollar';
      case debt_registry.DebtRegistryEntryType.ChargeCard:
        return 'credit-card';
      case debt_registry.DebtRegistryEntryType.CreditFacility:
        return 'bank-account';
      default:
        return undefined;
    }
  };

  return (
    <Tag minimal intent={getColor()} round icon={getIcon()}>
      {getName()}
    </Tag>
  );
};
